import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getApps } from "../../../action/masters/appActionCreator";
import { getWidgets } from "../../../action/masters/widgetActionCreator";
import { IWidgetAppDisplayOrder } from "../../../models/settings/studentSettings";
import { setApps } from "../../../store/slices/master/appSlice";
import { setWidgets } from "../../../store/slices/master/widgetSlice";
import WidgetPriority from "./priorityMasters/widgetPriority";
import AppPriority from "./priorityMasters/appPriority";
import { IWidgets } from "../../../models/master/widgets";
import { IApps } from "../../../models/master/apps";

const WidgetAppDisplayOrder = () => {
  return (
    <>
      <div className="col-md-6 mt-40">
        <div className="card-wrap settings-wrap">
          <h2>Widget Display Order</h2>
          <WidgetPriority/>
        </div>
      </div>
      <div className="col-md-6 mt-40">
        <div className="card-wrap settings-wrap">
          <h2>Apps Display Order</h2>
          {<AppPriority/>}
        </div>
      </div>
    </>
  );
};

export default WidgetAppDisplayOrder;